var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "addEditForm" },
    [
      _c(
        "el-form",
        {
          ref: "projectForm",
          attrs: { model: _vm.form, "label-width": "170px", rules: _vm.rules },
        },
        [
          _c(
            "el-row",
            { staticClass: "marRight20" },
            [
              _c(
                "el-form-item",
                { attrs: { label: "项目名称：", prop: "matchName" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入项目名称" },
                    model: {
                      value: _vm.form.matchName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "matchName", $$v)
                      },
                      expression: "form.matchName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "项目类型：", prop: "matchType" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "请输入项目类型" },
                      model: {
                        value: _vm.form.matchType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "matchType", $$v)
                        },
                        expression: "form.matchType",
                      },
                    },
                    _vm._l(_vm.list, function (i) {
                      return _c("el-option", {
                        key: i.id,
                        attrs: { label: i.matchTypeName, value: i.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "专业大类：", prop: "majorId" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "请输入专业大类" },
                      model: {
                        value: _vm.form.majorId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "majorId", $$v)
                        },
                        expression: "form.majorId",
                      },
                    },
                    _vm._l(_vm.majorList, function (i) {
                      return _c("el-option", {
                        key: i.id,
                        attrs: { label: i.majorName, value: i.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "项目年份：", prop: "matchYear" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "请输入项目年份" },
                      model: {
                        value: _vm.form.matchYear,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "matchYear", $$v)
                        },
                        expression: "form.matchYear",
                      },
                    },
                    _vm._l(_vm.yearList, function (i) {
                      return _c("el-option", {
                        key: i.value,
                        attrs: { label: i.label, value: i.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "参赛类型：", prop: "partyType" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.partyType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "partyType", $$v)
                        },
                        expression: "form.partyType",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "1" } }, [
                        _vm._v("个人赛"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: "2" } }, [
                        _vm._v("团队赛"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "报名组数", prop: "partyTeamNum" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "报名组数(输入-1表示不限)" },
                    model: {
                      value: _vm.form.partyTeamNum,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "partyTeamNum", $$v)
                      },
                      expression: "form.partyTeamNum",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "参赛人数" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "参赛人数" },
                    model: {
                      value: _vm.form.maxPartyNum,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "maxPartyNum", $$v)
                      },
                      expression: "form.maxPartyNum",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "报名开始结束时间：", required: "" } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 11 } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "datetime",
                          placeholder: "选择开始时间",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                        },
                        model: {
                          value: _vm.form.startTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "startTime", $$v)
                          },
                          expression: "form.startTime",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    {
                      staticStyle: { "text-align": "center" },
                      attrs: { span: 2 },
                    },
                    [_vm._v("至")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 11 } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "datetime",
                          placeholder: "选择结束时间",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                        },
                        model: {
                          value: _vm.form.endTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "endTime", $$v)
                          },
                          expression: "form.endTime",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "审核结束时间：", prop: "auditEndTime" } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 11 } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "datetime",
                          placeholder: "选择结束时间",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                        },
                        model: {
                          value: _vm.form.auditEndTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "auditEndTime", $$v)
                          },
                          expression: "form.auditEndTime",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "submitBtn" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small" },
              on: {
                click: function ($event) {
                  return _vm.submit("projectForm")
                },
              },
            },
            [_vm._v("保存")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.isBack } },
            [_vm._v("返回")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }